import {XtAxios,XtAxios4,setHeader} from "./XtAxios";
import {XtSocket,XtSocketPublic,XtSocketPrivate,setListenKey} from "./XtSocket";
import XtSocketFuture from "./XtSocketFuture";
export default {XtAxios,XtAxios4,setHeader,XtSocket,XtSocketPublic,XtSocketPrivate,setListenKey,XtSocketFuture};